import { stat } from 'fs'
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    studentLabel: 'student',
    cuid: null,
    drawer: false,
    sellItems: {},
    reload: false,
    startDate: null,
    application: false,
    full_name: 'ابر ایرانی',
    fullname: 'ابر ایرانی',
    dark: false,
    access: false,
    theme_color: false,
    abrName: null,
    hoverMenu: null,
    logo: null,
    date_locale: null,
    negative_inventory: 'no',
    rtl: true,
    app_key: null,
    date_format: null,
    menuBookmark: null,
    permissions: null,
    year: null,
    endDate: null,
    rank: null,
    portal: null,
    sazito: null,
    webzi: null,
    basalam: null,
    translationSystem: null,
    learningSystem: null,
    shopSystem: null,
    woocommerce: null,
    digikala: null,
    markito: null,
    webhook: null,
    gateway: null,
    onlineInvoice: null,
    absentSms: null,
    currencyName: 'ریال',
    currency: { amount: 1, id: 1, name: '', symbol: '' },
    currencyInput: false,
    currencyRate: 1,
    currencySymbol: '',
    iranSansEnNum: null,
    userId: null,
    quickAccount: null,
    bottomNavigate: true,
    admin: null,
    accessType: null,
    isMainYear: null,
    teacherAccess: null,
    shortcutItems: [],
    backgroundImage: null,
    backgroundColor: null,
    appBarsOpacity: null,
    components: [],
    menu: null,
    financialYear: null,
    sellInvoiceWithoutCustomer: false,
    defaultCustomer: null,
    allConfig: null,
    topMenu: [],
    offlineInvoiceTrigger: false,
    mobileDialogStatus: false,
    expireDate: null,
    smsCountRemain: null,
    tax: 10,
    mobileAppTab: 0,
    reloadShortcut: false,
    tableHeightInvoice: 0,
    lang: 'fa',
    preInput: null,
    invoiceData: null,
    autoFocus: true,
    crtlKey: false,
    isMenuExpanded: JSON.parse(localStorage.getItem('isMenuExpanded')) ?? true,
    isMobileMenuOpen: false,
    isPlanDialogOpen: false,
    userCurrentPlan: null,
    integratorTab: null,
    routeCacheVersion: {},
    removedParamsId: null,
    ticketNewCount: 0,
    chatUnreadCount: 0,
    userData: {name: null, avatar: null, username: null}
  },
  getters: {
    menuBookmark({ menuBookmark }) {
      return menuBookmark
    },
    getpermission({ permissions }) {
      return permissions
    }
  },
  mutations: {
    REMOVE_COMPONENTS: (state, payload) => {
      const i = state.components.map(item => item.path).indexOf(payload.path)
      if (i !== -1) {
        state.components.splice(i, 1)
      }
      const v = (state.routeCacheVersion[payload.path] || 0) + 1
      Vue.set(state.routeCacheVersion, payload.path, v)
    },
    SET_AUTOFOCUS(state, payload) {
      state.autoFocus = payload
    },
    SET_PREINPUT(state, payload) {
      state.preInput = payload
    },
    SET_CRTLKEY(state, payload) {
      state.crtlKey = payload
    },
    SET_CUID(state, payload) {
      state.cuid = payload
    },
    SET_OFFLINEINVOICETRIGGER(state, payload) {
      state.offlineInvoiceTrigger = payload
    },
    SET_TABLEHEIGHTINVOICE(state, payload) {
      state.tableHeightInvoice = payload
    },
    SET_MOBILEDIALOGSTATUS(state, payload) {
      state.mobileDialogStatus = payload
    },
    SET_INVOICEDATA(state, payload) {
      state.invoiceData = payload
    },
    SET_RELOAD(state, payload) {
      state.reload = payload
    },
    SET_RELOADSHORTCUT(state, payload) {
      state.reloadShortcut = payload
    },
    SET_SELLINVOICEWITHOUTCUSTOMER(state, payload) {
      state.sellInvoiceWithoutCustomer = payload
    },
    SET_APPLICATION(state, payload) {
      state.application = payload
    },
    SET_STUDENTLABEL(state, payload) {
      state.studentLabel = payload
    },
    SET_SMSCOUNTREMAIN(state, payload) {
      state.smsCountRemain = payload
    },
    SET_EXPIREDATE(state, payload) {
      state.expireDate = payload
    },
    SET_DEFAULTCUSTOMER(state, payload) {
      state.defaultCustomer = payload
    },
    SET_MOBILEAPPTAB(state, payload) {
      state.mobileAppTab = payload
    },
    SET_ALLCONFIG(state, payload) {
      state.allConfig = payload
    },
    SET_USERID(state, payload) {
      state.userId = payload
    },
    SET_TICKET_NEW_COUNT(state, payload) {
      state.ticketNewCount = payload
    },
    SET_CHAT_UNREAD_COUNT(state, payload) {
      state.chatUnreadCount = Number(payload) || 0
    },
    SET_BACKGROUNDIMAGE(state, payload) {
      state.backgroundImage = payload
    },
    SET_BOTTOMNAVIGATE(state, payload) {
      state.bottomNavigate = payload
    },
    SET_APPBARSOPACITY(state, payload) {
      state.appBarsOpacity = payload
    },
    SET_BACKGROUNDCOLOR(state, payload) {
      state.backgroundColor = payload
    },
    SET_FINANCIALYEAR(state, payload) {
      state.financialYear = payload
    },
    SET_ISMAINYEAR(state, payload) {
      state.isMainYear = payload
    },
    SET_ACCESSTYPE(state, payload) {
      state.accessType = payload
    },
    SET_CURRENCYINPUT(state, payload) {
      state.currencyInput = payload
    },
    SET_TEACHERACCESS(state, payload) {
      state.teacherAccess = payload
    },
    SET_TOPMENU(state, payload) {
      state.topMenu = payload
    },
    SET_IRANSANSENNUM(state, payload) {
      state.iranSansEnNum = payload
    },
    SET_ADMIN(state, payload) {
      state.admin = payload
    },
    CLEAR_COMPONENTS: (state, payload) => {
      state.components = []
    },
    SET_MENU: (state, payload) => {
      state.menu = payload
    },
    SET_PORTAL: (state, payload) => {
      state.portal = payload
    },
    SET_BASALAM: (state, payload) => {
      state.basalam = payload
    },
    SET_WEBZI: (state, payload) => {
      state.webzi = payload
    },
    SET_SAZITO: (state, payload) => {
      state.sazito = payload
    },
    SET_TRANSLATIONSYSTEM: (state, payload) => {
      state.translationSystem = payload
    },
    SET_LEARNINGSYSTEM: (state, payload) => {
      state.learningSystem = payload
    },
    SET_SHOPSYSTEM: (state, payload) => {
      state.shopSystem = payload
    },
    SET_WOOCOMMERCE: (state, payload) => {
      state.woocommerce = payload
    },
    SET_DIGIKALA: (state, payload) => {
      state.digikala = payload
    },
    SET_MARKITO: (state, payload) => {
      state.markito = payload
    },
    SET_WEBHOOK: (state, payload) => {
      state.webhook = payload
    },
    SET_ONLINEINVOICE: (state, payload) => {
      state.onlineInvoice = payload
    },
    SET_ABSENTSMS: (state, payload) => {
      state.absentSms = payload
    },
    SET_GATEWAY: (state, payload) => {
      state.gateway = payload
    },
    // SET_COMPONENTS (state, payload) {
    //   state.components.push(payload)
    // },
    SET_COMPONENTS (state, payload) {
      const routeSnapshot = {
        path: payload.path,
        name: payload.name,
        query: payload.query ? { ...payload.query } : {},
        params: payload.params ? { ...payload.params } : {}
      }
      const exists = state.components.find(c =>
        c.path === routeSnapshot.path &&
        JSON.stringify(c.query) === JSON.stringify(routeSnapshot.query) &&
        JSON.stringify(c.params) === JSON.stringify(routeSnapshot.params)
      )
      if (!exists) {
        state.components.push(routeSnapshot)
      }
    },
    SET_SHORTCUT_ITEMS(state, payload) {
      state.shortcutItems.push(payload)
    },
    SET_LOGO(state, payload) {
      state.logo = payload
    },
    SET_HOVERMENU(state, payload) {
      state.hoverMenu = payload
    },
    SET_ABRNAME(state, payload) {
      state.abrName = payload
    },
    SET_YEAR(state, payload) {
      state.year = payload
    },
    SET_ACCESS(state, payload) {
      state.access = payload
    },
    SET_FULLNAME(state, payload) {
      state.fullname = payload
    },
    SET_QUICK_ACCOUNT(state, payload) {
      state.quickAccount = payload
    },
    ADD_SELL_ITEM(state, payload) {
      state.sellItems[payload.id] = payload
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_START_DATE(state, payload) {
      state.startDate = payload
    },
    SET_END_DATE(state, payload) {
      state.endDate = payload
    },
    SET_APP_KEY(state, payload) {
      state.app_key = payload
    },
    SET_THEME_COLOR(state, payload) {
      state.theme_color = payload
    },
    SET_RTL(state, payload) {
      state.rtl = payload
    },
    SET_DARK(state, payload) {
      state.dark = payload
    },
    SET_LANG(state, payload) {
      state.lang = payload
    },
    SET_DATE_LOCALE(state, payload) {
      state.date_locale = payload
    },
    SET_DATE_FORMAT(state, payload) {
      state.date_format = payload
    },
    SET_CURRENCY_SYMBOL(state, payload) {
      state.currencySymbol = payload
    },
    SET_NEGATIVE_INVENTORY(state, payload) {
      state.negative_inventory = payload
    },
    SET_CURRENCY(state, payload) {
      state.currency = payload
    },
    SET_MENU_BOOKMARK(state, payload) {
      state.menuBookmark = payload
    },
    SET_PERMISSIONS(state, payload) {
      state.permissions = payload
    },
    SET_RANK(state, payload) {
      state.rank = payload
    },
    SET_MENU_EXPANDED(state, payload) {
      state.isMenuExpanded = payload
      localStorage.setItem('isMenuExpanded', JSON.stringify(payload))
    },
    SET_MOBILE_MENU(state, payload) {
      state.isMobileMenuOpen = payload
    },
    SET_PLAN_DIALOG(state, payload) {
      state.isPlanDialogOpen = payload
    },
    SET_USER_CURRENT_PLAN(state, payload) {
      state.userCurrentPlan = payload
    },
    SET_INTEGRATOR_TAB(state, payload) {
      state.integratorTab = payload
    },
    SET_REMOVED_PARAMS_ID(state, payload) {
      state.removedParamsId = payload
    },
    SET_NAME (state, payload) {
      state.userData.name = payload
    },
    SET_AVATAR (state, payload) {
      state.userData.avatar = payload
    },
    SET_USERNAME (state, payload) {
      state.userData.username = payload
    }
  },
  actions: {
    removeAccount({ commit }, id) {
      if (!id) {
        console.error("Missing ID for removeAccount route");
        return;
      }
      this.$router.push({ name: "removeAccount", params: { id } });
    }
  }
})
